import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

function* sendUnmaskingInvitationBulk({ payload: { uuids, onSuccess, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.unmasking.invitations.send, data: uuids.map(uuid => ({ invited_uuid: uuid })) });

    onSuccess && onSuccess(data.results);
    yield put(actions.sendUnmaskingInvitationBulkDone(data.results));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.sendUnmaskingInvitationBulkFailed,
      handledErrors,
      endpoint: api.unmasking.invitations.send.url
    });
  }
}

export const sendUnmaskingInvitationBulkSaga = takeEvery(types.SEND_UNMASKING_INVITATION_BULK_REQUEST, sendUnmaskingInvitationBulk);